import FileOpenIcon from '@mui/icons-material/FileOpen';
import FormTemplateCreate from './FormTemplateCreate';
import FormTemplateEdit from './FormTemplateEdit';
import FormTemplateList from './FormTemplateList';

export default {
  list: FormTemplateList,
  edit: FormTemplateEdit,
  icon: FileOpenIcon,
  create: FormTemplateCreate,
  recordRepresentation: (record: any) => `${record.name}`,
};
